module.exports = __webpack_public_path__ + "img/album14_34.19f3d23b.jpg";